import { useQuery } from "@tanstack/react-query"
import { Moment } from "config"
import { API } from "config"

const useBonusMentor = (period) => useQuery({ queryKey: ['bonus-mentor', period], queryFn: async () => {
    const callback = await API.get(`/tools/bonus-mentor?start_at=${Moment(period[0]).unix()}&end_at=${Moment(period[1]).unix()}`)
    return callback?.data
}})

export default useBonusMentor